import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetSignalsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetSignalsResponseDataSchema>>

type Props = {
  dateRange: {
    from: Date
    to: Date
  }
  enabled?: boolean
}

export const getSignalsQueryKey = (props?: Props) => ["signals", props].filter(Boolean)

export const signalsQuery = (props: Props) => {
  return queryOptions({
    queryKey: getSignalsQueryKey(props),
    queryFn: async () => {
      const { data } = await axios.post<Response>("/insights/signals", {
        dateRange: {
          from: props.dateRange.from.toISOString(),
          to: props.dateRange.to.toISOString(),
        },
      })
      return data.data
    },
    enabled: props.enabled,
  })
}
